export default "/template/resource//static/media/img_wushujutuisong@2x.9cc766b1.png";